export default "__VITE_ASSET__Gcp3oU72__"